import {type ICurrencyConfiguration} from '../../../@type/woocommerce/currency-configuration';
import {type IMerchantConfiguration} from '../models/IMerchantConfiguration';
import {type DispatchAction, store} from '../store';
import {DispatchActionType} from '../models/DispatchActionType';
import {createDispatchUpdate} from './initialState';

/**
 * Merchant settings reducer.
 */
export function merchantConfigurationReducer(state: IMerchantConfiguration, action: DispatchAction<unknown>): IMerchantConfiguration {
	switch (action.type) {
		case DispatchActionType.MERCHANT_GENERAL_CURRENCY:
			return {
				...state,
				general: {
					...state.general,
					currency: {
						...(action as DispatchAction<ICurrencyConfiguration>).payload,
					},
				},
			};
		case DispatchActionType.MERCHANT_GENERAL:
			return {
				...state,
				general: {
					...(action as DispatchAction<IMerchantConfiguration['general']>).payload,
				},
			};
		case DispatchActionType.MERCHANT_TAX:
			return {
				...state,
				tax: {
					...(action as DispatchAction<IMerchantConfiguration['tax']>).payload,
				},
			};
		case DispatchActionType.MERCHANT_SHIPPING:
			return {
				...state,
				shipping: {
					...(action as DispatchAction<IMerchantConfiguration['shipping']>).payload,
				},
			};
		case DispatchActionType.MERCHANT_HOSTNAME:
			return {
				...state,
				hostName: (action as DispatchAction<string>).payload,
			};
		case DispatchActionType.MERCHANT_NAME:
			return {
				...state,
				name: (action as DispatchAction<string>).payload,
			};
		case DispatchActionType.MERCHANT_ID:
			return {
				...state,
				id: (action as DispatchAction<string>).payload,
			};
		default:
			return {...state};
	}
}

// ======================== Action Creators ==============================

export const updateMerchantCurrencyConfig = createDispatchUpdate<ICurrencyConfiguration>(DispatchActionType.MERCHANT_GENERAL_CURRENCY);
export const updateMerchantTaxConfig = createDispatchUpdate<IMerchantConfiguration['tax']>(DispatchActionType.MERCHANT_TAX);
export const updateMerchantGeneralConfig = createDispatchUpdate<IMerchantConfiguration['general']>(DispatchActionType.MERCHANT_GENERAL);
export const updateMerchantShippingConfig = createDispatchUpdate<IMerchantConfiguration['shipping']>(DispatchActionType.MERCHANT_SHIPPING);
export const updateMerchantHostName = createDispatchUpdate<string>(DispatchActionType.MERCHANT_HOSTNAME);
export const updateMerchantName = createDispatchUpdate<string>(DispatchActionType.MERCHANT_NAME);
export const updateMerchantId = createDispatchUpdate<string>(DispatchActionType.MERCHANT_ID);

// ========================= Store Selectors ===========================

export const MerchantConfiguration = {
	id: () => store.getState().merchantConfiguration.id,
	name: () => store.getState().merchantConfiguration.name,
	hostName: () => store.getState().merchantConfiguration.hostName,
	general: {
		wcLocationInfoData: () => store.getState().merchantConfiguration.general.wcLocationInfoData,
	},
	currency: {
		configuration: () => store.getState().merchantConfiguration.general.currency,
		code: () => store.getState().merchantConfiguration.general.currency.code,
		symbol: () => store.getState().merchantConfiguration.general.currency.symbol,
	},
	tax: {
		displayMode: () => store.getState().merchantConfiguration.tax.displayPricesInCartAndCheckout,
	},
	shipping: {
		shippingZones: () => store.getState().merchantConfiguration.shipping.shippingZones,
	},
};
